// toggle.js

/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
/* eslint-disable space-before-function-paren */

$(document).ready(function () {
  // http://stackoverflow.com/questions/3642035/jquerys-append-not-working-with-svg-element
  $(window).on('resize', function () {
    $('*[data-cabin-toggle]').each(function (index, element) {
      var id = $(this).attr('data-cabin-toggle'); // var selection = $('[data-cabin-toggle=\'' + id + '\']');
      // reset

      $('#' + id).show(); // $(element).attr('class', 'js_toggle_up');

      $(element).removeClass('js_toggle_down').addClass('js_toggle_up'); // $('#'+ id).find('use').attr('xlink:href', '#shape-up-open');

      $('#' + id).find('svg').empty();
      $('#' + id).find('svg').append('<use xlink:href="#shape-up-open"/>');
      $('#' + id).html($('#' + id).html());

      if (element.offsetHeight + 10 < element.scrollHeight) {
        // show toggle button
        $('#' + id).show();
      } else {
        // hide toggle button
        $('#' + id).hide();
      }
    });
  }).resize();
  $('[id^="js_cabin_toggle_"]').click(function () {
    // var xlink = $(this).find('use').attr('xlink:href');
    var id = $(this).attr('id'); // var status =  $(this).parents('div').find("[data-cabin-toggle='" + id + "']").attr('id');

    var status = $(this).parents('div').find('[data-cabin-toggle=\'' + id + '\']').attr('class');
    var match = status.match(/js_toggle_up/g);
    $(this).find('svg').removeAttr('class');
    $(this).find('svg').empty();

    if (match == 'js_toggle_up') {
      // $(this).find('use').attr('xlink:href', '#shape-up-open');
      $(this).find('svg').append('<use xlink:href="#shape-down-open"/>');
      $(this).html($(this).html()); // $(this).parents('div').find("[data-cabin-toggle='" + id + "']").attr('class', 'js_toggle_up');

      $(this).parents('div').find('[data-cabin-toggle=\'' + id + '\']').removeClass('js_toggle_up').addClass('js_toggle_down');
    } else {
      // $(this).find('use').attr('xlink:href', '#shape-down-open');
      $(this).find('svg').append('<use xlink:href="#shape-up-open"/>');
      $(this).html($(this).html()); // $(this).parents('div').find("[data-cabin-toggle='" + id + "']").attr('class', 'js_toggle_down');

      $(this).parents('div').find('[data-cabin-toggle=\'' + id + '\']').removeClass('js_toggle_down').addClass('js_toggle_up');
    }

    return false;
  }); // $(window).trigger('resize');
});

//
// EOF
//
